<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
    :show="isLoading"
  >
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col cols="12">
            <vue-good-table
              :columns="columns"
              :rows="dataSources"
              :pagination-options="paginationOptions"
            >
              <div
                slot="emptystate"
                style="text-align: center; font-weight: bold"
              >
                Không có bản ghi nào !
              </div>
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span v-if="props.column.field === 'index'">
                    {{
                      (currentPage - 1) * itemsPerPage +
                      props.index +
                      1
                    }}
                </span>
                <span v-if="props.column.field === 'startDate'">
                  01/01/2025
                </span>
                <span v-if="props.column.field === 'endDate'">
                  17/10/2025
                </span>
                <span v-if="props.column.field === 'status'">
                  {{ getStatusName(props.row.status) }}
                </span>
                <span v-else-if="props.column.field === 'action'">
                  <b-dropdown
                    variant="link"
                    no-caret
                    :right="$store.state.appConfig.isRTL"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>
                    <b-dropdown-item @click="onShowStudentClassModal(props.row.id)">
                      <feather-icon icon="UsersIcon" />
                      <span class="align-middle ml-50">Danh sách học viên</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="onShowClassNotificationModal(props.row.id)">
                      <feather-icon icon="Volume2Icon" />
                      <span class="align-middle ml-50">Thông báo</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <template
                slot="pagination-bottom"
                slot-scope="props"
              >
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Hiển thị 1 đến </span>
                    <b-form-select
                      v-model="itemsPerPage"
                      :options="itemsPerPageOptions"
                      class="mx-1"
                      @input="(value) => props.perPageChanged({ currentPerPage: value })"
                    />
                    <span class="text-nowrap">của {{ props.total }} bản ghi</span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="itemsPerPage"
                      class="mt-1 mb-0"
                      @input="(value) => props.pageChanged({ currentPage: value })"
                    />
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <StudentClass :class-id="classId" />
    <ClassNotification :class-id="classId" />
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BCol, BOverlay, BRow, BDropdown, BDropdownItem, BPagination , BFormSelect
} from 'bootstrap-vue'
import { getUser } from '@/auth/utils'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ClassNotification from '@/views/study/class/ClassNotification.vue'
import StudentClass from '@/views/study/class/StudentClass.vue'

export default {
  name: 'Class',
  components: {
    StudentClass,
    ClassNotification,
    BCol,
    BRow,
    BCard,
    BCardBody,
    BOverlay,
    VueGoodTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormSelect
  },
  data() {
    return {
      isLoading: false,
      user: getUser(),
      columns: [
        {
          label: "STT",
          field: "index",
          width: "5%",
          sortable: false,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          field: 'code',
          label: 'Mã lớp',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'name',
          label: 'Tên lớp',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          field: 'teacher',
          label: 'Giảng viên CN',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        // {
        //   field: 'consultant',
        //   label: 'Cố vấn HT',
        //   sortable: false,
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        // },
        {
          field: 'startDate',
          label: 'Ngày bắt đầu',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          field: 'endDate',
          label: 'Ngày kết thúc',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          field: 'status',
          label: 'Trạng thái',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          field: 'action',
          label: 'Thao tác',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      currentPage: 1,
      itemsPerPage: 20,
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      classId: null,
      statusArray: [
        { value: 0, label: 'Đã kết thúc' },
        { value: 1, label: 'Đang học' },
      ]
    }
  },
  computed: {
    ...mapGetters({
      dataSources: 'study/classes',
    }),
    paginationOptions() {
      return {
        enabled: true,
        perPage: this.itemsPerPage,
      }
    },
  },
  async created() {
    await this.getDataSourceFromStore()
    const { groupId } = this.$route.query
    if (groupId) {
      // eslint-disable-next-line radix
      this.onShowClassNotificationModal(groupId)
    }
  },
  beforeRouteUpdate(to, from, next) {
    const newGroupId = to.query.groupId
    if (newGroupId) {
      this.onShowClassNotificationModal(newGroupId)
    }
    next() // Tiếp tục điều hướng
  },
  methods: {
    ...mapMutations({
      setDataSources: 'study/SET_CLASSES',
    }),
    ...mapActions({
      getClassesByStudentAndProgramme: 'study/getClassesByStudentAndProgramme',
    }),
    async getDataSourceFromStore() {
      const programmeId = this.user.portalProgrammeId
      if (!programmeId) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Học viên không theo học chương trình đào tạo nào',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        this.setDataSources([])
        return
      }
      this.isLoading = true
      try {
        await this.getClassesByStudentAndProgramme({ studentId: this.user.studentId, programmeId })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    getStatusName(id) {
      return this.statusArray.find(status => status.value === id).label
    },
    onShowStudentClassModal(id) {
      this.classId = id
      this.$bvModal.show('studentClassModal')
    },
    onShowClassNotificationModal(id) {
      this.classId = id
      this.$bvModal.show('classNotificationModal')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table';
</style>
